import { useState } from "react";
import { BooleanSwitchValue } from "consts/general";
import { postOnboardingsApplications } from "features/ecommerce/api";
import { useOnboardingActions } from "ui/organizms/ECommerce/Onboarding/common";

export const useOnboardingGettingStarted = () => {
    const [isLoading, setLoading] = useState(false);

    const { complete } = useOnboardingActions({
        save: postOnboardingsApplications,
        onError: () => setLoading(false)
    });

    const onComplete = () => {
        setLoading(true);

        return complete({
            hasAgreedTermsConditions: BooleanSwitchValue.Off
        });
    };

    return {
        isLoading,
        onComplete
    };
};

export default useOnboardingGettingStarted;
